import React from 'react';
import Badge from '@material-ui/core/Badge';
import { ResourceRequestIcon } from '~/modules/common/components/Icons';
import { ResourceRequestAccessLevel } from '~/types';
import {
  useResourcePlanSummaryCounts,
  useResourcePlanSummaryCountRefetchSubscription
} from './common/hooks';

export const MAX_NOTIFICATIONS = 9;

export const ResourcingBadgeIcon = () => {
  const {
    loading,
    pendingCount = 0,
    allocationRejectedCount,
    refetch
  } = useResourcePlanSummaryCounts({
    requestAccessLevel: ResourceRequestAccessLevel.ResourceManager
  });

  const resourceCount = pendingCount + allocationRejectedCount;

  useResourcePlanSummaryCountRefetchSubscription({ refetch });

  if (!loading && resourceCount > 0) {
    return (
      <Badge
        overlap="rectangular"
        badgeContent={
          resourceCount > MAX_NOTIFICATIONS
            ? `${MAX_NOTIFICATIONS}+`
            : resourceCount
        }
        color="secondary"
        data-qe-id="resourcing_Count"
      >
        <ResourceRequestIcon />
      </Badge>
    );
  }

  return <ResourceRequestIcon />;
};

export default ResourcingBadgeIcon;
